import { ModelBase } from 'store/model-base';

export class CmsMyAccount extends ModelBase {
    public static storeName: string = 'cmsMyAccount';

    public totalPayment: CmsTotalPayment;
    public breadcrumbs: AccountBreadcrumbLabels;
    public creditCard: CmsCreditCard;
    public notificationBannerResi: CmsNotificationBanner[];
    public notificationBannerCBM: CmsNotificationBanner[];
    public prodOutageNotificationBanner: CmsNotificationBanner;
    public addressFooter: CmsBillingAddressFooter;
    public addressFooterForBusiness: CmsBillingAddressFooter;
    public error: CmsErrorDetails;
    public plans: CmsDataPlans;
    public secondaryMenuItems: CmsNavMenuItems[];
    public apiFailureModalData: DescriptiveModalData;
}
